new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args
  el: '#footer',
  data: {

  },
});

/* Sobre: mostra os primeiros parágrafos (quantos, é o $about-collapsed-items do
   footer.scss) e alterna entre Ver mais / Ver menos. O botão é criado aqui, o
   admin só cadastra a imagem e o texto. */
const ABOUT_LABEL_MORE = 'Ver mais';
const ABOUT_LABEL_LESS = 'Ver menos';
const ABOUT_TRANSITION = 700;

function initAboutSeeMore() {
  const about = document.querySelector('.product-list__section--sobre .about');
  if (!about) return;

  const figcaption = about.querySelector('figure figcaption');
  if (!figcaption) return;

  // O conteúdo vem do admin, então pode trazer botões/links "ver mais" e alturas
  // inline salvos junto com o texto. Limpa tudo antes de montar o controle.
  figcaption.querySelectorAll('.see-more').forEach(el => el.remove());
  figcaption.querySelectorAll('a').forEach(link => {
    const label = link.textContent.trim().toLowerCase();
    if (label === 'ver mais' || label === 'ver menos') link.remove();
  });

  let text = figcaption.querySelector('.about-text');
  if (!text) {
    text = document.createElement('div');
    text.className = 'about-text';
    Array.from(figcaption.childNodes).forEach(node => {
      const isHeading = node.nodeType === 1 && /^H[1-6]$/.test(node.tagName);
      if (!isHeading) text.appendChild(node);
    });
    figcaption.appendChild(text);
  }
  text.removeAttribute('style');
  text.querySelectorAll('[style]').forEach(el => el.removeAttribute('style'));

  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'see-more';
  button.textContent = ABOUT_LABEL_MORE;
  button.setAttribute('aria-expanded', 'false');
  figcaption.appendChild(button);

  let expanded = false;
  let animating = false;
  let animationTimer;

  // Enquanto a transição de height está armada, qualquer medida síncrona devolve
  // a altura atual e não a nova. Toda medição precisa rodar aqui dentro.
  const withoutTransition = (callback) => {
    text.style.transition = 'none';
    const result = callback();
    void text.offsetHeight; // aplica o estado final antes de rearmar a transição
    text.style.transition = '';
    return result;
  };

  const render = () => {
    if (animating) return;

    withoutTransition(() => {
      text.style.height = '';

      about.classList.remove('is-clamped');
      const fullHeight = text.scrollHeight;

      about.classList.add('is-clamped');
      const clampedHeight = text.getBoundingClientRect().height;

      const collapsible = fullHeight > clampedHeight + 1;
      about.classList.toggle('is-collapsible', collapsible);
      about.classList.toggle('is-clamped', collapsible && !expanded);
      button.hidden = !collapsible;

      if (!collapsible) {
        expanded = false;
        about.classList.remove('is-expanded');
        button.textContent = ABOUT_LABEL_MORE;
        button.setAttribute('aria-expanded', 'false');
      }
    });
  };

  const settle = () => {
    clearTimeout(animationTimer);
    animating = false;

    withoutTransition(() => {
      about.classList.toggle('is-clamped', !expanded);
      text.style.height = '';
    });
  };

  const toggle = () => {
    if (animating) return;

    const start = text.getBoundingClientRect().height;

    const target = withoutTransition(() => {
      text.style.height = '';

      let value;
      if (expanded) {
        // Recolhendo: mede a altura truncada, mas só reaplica o clamp no fim da
        // transição, senão o texto sumiria antes de a caixa fechar.
        about.classList.add('is-clamped');
        value = Math.round(text.getBoundingClientRect().height);
        about.classList.remove('is-clamped');
      } else {
        about.classList.remove('is-clamped');
        value = text.scrollHeight;
      }

      text.style.height = `${start}px`;
      return value;
    });

    expanded = !expanded;
    about.classList.toggle('is-expanded', expanded);
    button.textContent = expanded ? ABOUT_LABEL_LESS : ABOUT_LABEL_MORE;
    button.setAttribute('aria-expanded', String(expanded));

    animating = true;
    text.style.height = `${target}px`;

    // Rede de segurança para quando o transitionend não dispara
    animationTimer = setTimeout(settle, ABOUT_TRANSITION + 100);
  };

  button.addEventListener('click', toggle);

  text.addEventListener('transitionend', event => {
    if (event.target !== text || event.propertyName !== 'height') return;
    settle();
  });

  render();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAboutSeeMore);
} else {
  initAboutSeeMore();
}
